var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkHospitalSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.1758V8.82422H12.1758V6.5H9.82422V8.82422H7.5V11.1758H9.82422V13.5H12.1758V11.1758H14.5ZM15.0742 4.75C15.3841 4.75 15.6576 4.86849 15.8945 5.10547C16.1315 5.34245 16.25 5.61589 16.25 5.92578V14.0742C16.25 14.3841 16.1315 14.6576 15.8945 14.8945C15.6576 15.1315 15.3841 15.25 15.0742 15.25H6.92578C6.61589 15.25 6.34245 15.1315 6.10547 14.8945C5.86849 14.6576 5.75 14.3841 5.75 14.0742V5.92578C5.75 5.61589 5.86849 5.34245 6.10547 5.10547C6.34245 4.86849 6.61589 4.75 6.92578 4.75H15.0742Z",
    fill: "#1F4546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93506 18.6423L11 18.716L17.065 18.7897L11.7027 23.2893C11.2796 23.6443 10.6008 23.636 10.1864 23.2708L4.93506 18.6423Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkHospitalSmall);
export default __webpack_public_path__ + "static/media/mark-hospital-small.0534e4c4a708a447ac572e4a9cbbd51b.svg";
export { ForwardRef as ReactComponent };